import React, { Component } from 'react';
import TableC from '../../../basicElement/TableC';
import moment from 'moment';


class ResearcherInfo extends Component {

    getColumns = () => {
        const { type } = this.props;
        const columns = [
            {
                title: '序号',
                dataIndex: 'sortNum',
                key: 'sortNum',
                width: 60,
            },
            {
                title: '专业名称',
                dataIndex: 'profAllName',
                key: 'profAllName',
                width: 100,
            },
            {
                title: '主要研究者',
                dataIndex: 'profPersonName',
                key: 'profPersonName',
                width: 100,
            },
            {
                title: '职称',
                dataIndex: 'profPersonPost',
                key: 'profPersonPost',
                width: 100,
            },
        ];
        if (type == '02') {
            columns.push(
                {
                    title: '备案时间',
                    dataIndex: 'initDate',
                    key: 'initDate',
                    width: 100,
                    render: text => text ? moment(text).format('YYYY-MM-DD'): ''
                },
            )
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.props;
        const dataSource = [];
        (data || []).map((el, index) => {
            dataSource.push({
                ...el,
                sortNum: (pagination.current - 1) * 10 + index + 1,
            });
        });
        return dataSource
    }

    render() {
        const { pagination, handleTableChange } = this.props;

        return (
            <div>
                <TableC
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={pagination}
                />
            </div>
        );
    }
}


export default ResearcherInfo


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/ResearcherInfo.js